export const text = '#404040';
export const hover = '#1961AC';
